/**
 * Browser Sentry events that are not defects and must not file issues.
 *
 * A request the page cancelled itself — the user navigated away, React Query dropped a
 * superseded query — rejects with an AbortError ("The user aborted a request."). It
 * filed Sentry HFV3-FRONTEND-P on staging (2026-09-24). A TimeoutError is NOT dropped:
 * that is a request that failed, not one we cancelled.
 */
interface EventLike {
  exception?: { values?: Array<{ type?: string; value?: string }> }
}

const ABORT_VALUE =
  /\bAbortError\b|The user aborted a request|signal is aborted without reason|The operation was aborted\.$/

export function isAbortedRequestEvent(event: EventLike): boolean {
  const values = event.exception?.values ?? []
  if (values.length === 0) return false
  return values.every((v) => {
    if (v.type === 'TimeoutError') return false
    return v.type === 'AbortError' || ABORT_VALUE.test(v.value ?? '')
  })
}
